import { getLink } from '@helpers/env'

import styles from './styles.module.scss'
import Link from '@components/ui/Link'

const getLinks = () => {
  const links = [
    {
      href: getLink('/pages/privacy'),
      text: 'Privacy',
      target: '_blank',
      rel: 'noopener noreferrer'
    },
    {
      href: '/pages/terms',
      text: 'Terms',
      target: '_blank'
    }
  ]

  return links
}

export default function FooterBaseLinks() {
  const links = getLinks()
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  return (
    <>
      <div className={styles.FooterBaseLinks}>
        <span>
          &copy; {currentYear} SPOKE<sup>TM</sup>
        </span>
        {links.map(({ text, href, target }) => (
          <Link
            text={text}
            href={href}
            target={target}
            underlined={false}
            key={text}
          />
        ))}
      </div>
    </>
  )
}
